"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _whiteX = _interopRequireDefault(require("../../../../images/white-x.svg"));

var _whiteBackArrow = _interopRequireDefault(require("../../../../images/white-back-arrow.svg"));

require("./SolidColorModalHeader.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SolidColorModalHeader = function SolidColorModalHeader(_ref) {
  var closeModal = _ref.closeModal,
      headerCopy = _ref.headerCopy,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? 'black' : _ref$backgroundColor,
      _ref$fontColor = _ref.fontColor,
      fontColor = _ref$fontColor === void 0 ? 'white' : _ref$fontColor,
      handleGoBack = _ref.handleGoBack;
  var headerBackgroundClasses = (0, _classnames.default)('modal-2020-solid-header', _defineProperty({}, backgroundColor, backgroundColor));
  var fontClasses = (0, _classnames.default)('copy-header', _defineProperty({}, fontColor, fontColor));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: headerBackgroundClasses
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "handle-back",
    onClick: handleGoBack
  }, handleGoBack && /*#__PURE__*/_react.default.createElement("img", {
    src: _whiteBackArrow.default,
    alt: "white-back-arrow"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: fontClasses
  }, headerCopy), /*#__PURE__*/_react.default.createElement("button", {
    className: "close-modal",
    onClick: closeModal
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _whiteX.default,
    alt: "close-modal"
  })));
};

var string = _propTypes.default.string,
    func = _propTypes.default.func,
    oneOf = _propTypes.default.oneOf;
SolidColorModalHeader.propTypes = {
  closeModal: func.isRequired,
  headerCopy: string.isRequired,
  type: oneOf(['primary', 'delete'])
};
var _default = SolidColorModalHeader;
exports.default = _default;